const useTypeSession = () => {
    const url = new URLSearchParams(window.location.search);
    const type = url.get("type") || 'pf';
    
    return type;
};

export default useTypeSession;
